module.exports = __webpack_public_path__ + "img/4c0298b7033572834c21c8c4ba92b3e.63c3184e.jpg";